const topics = [
  { title: '院线大片', desc: '最新上映热门影片', icon: 'ri-film-line', count: '326部' },
  { title: '动作猛片', desc: '肾上腺素飙升之作', icon: 'ri-flashlight-line', count: '1,852部' },
  { title: '喜剧合集', desc: '开怀大笑解压必备', icon: 'ri-emotion-laugh-line', count: '964部' },
  { title: '科幻巨制', desc: '想象力的极限突破', icon: 'ri-rocket-line', count: '718部' },
  { title: '悬疑烧脑', desc: '反转不断全程高能', icon: 'ri-search-eye-line', count: '543部' },
  { title: '动漫精选', desc: '日漫国漫一网打尽', icon: 'ri-ghost-line', count: '2,103部' },
  { title: '纪录纪实', desc: '真实世界的震撼', icon: 'ri-earth-line', count: '415部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">精选专题</h2>
          <p className="text-foreground-500 text-sm mt-2">分类浏览，快速找到你想看的影片</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4">
          {topics.map((item) => (
            <a
              key={item.title}
              href="#index"
              className="group p-4 md:p-5 bg-background-100 hover:bg-background-200 rounded-xl border border-background-200/60 hover:border-primary-500/40 transition-all cursor-pointer text-center"
            >
              <div className="w-11 h-11 mx-auto flex items-center justify-center bg-primary-500/15 rounded-xl group-hover:bg-primary-500/25 transition-colors">
                <i className={`${item.icon} text-primary-400 text-lg`}></i>
              </div>
              <h3 className="mt-3 font-heading text-sm md:text-base font-semibold text-foreground-200 group-hover:text-primary-400 transition-colors">
                {item.title}
              </h3>
              <p className="text-foreground-600 text-xs mt-1">{item.desc}</p>
              <span className="inline-block mt-2 text-[10px] text-primary-400 bg-primary-500/10 px-2 py-0.5 rounded-full">
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}